import { play } from "@voomp/play-back"
import { defineStore } from "pinia"
import { ref, watch } from "vue"
import { useAuthStore } from "./auth.store"

export const useNotificationStore = defineStore('notification', () => {
  const authStore = useAuthStore()
  const all = ref<Record<string, unknown>[]>([])

  async function fetch() {
    if (!authStore.getMemberId() || !authStore.getSiteId()) {
      all.value = []
      return;
    }
    all.value = await play.notification.list_all({})
  }  

  function getUnreadCount() {
    const count = all.value.filter(notification => !notification.read_at).length
    return count > 9 ? '9+' : count.toString()
  }

  function getFirsts() {
    return all.value.slice(0, 10)
  }

  async function markAsRead(id: string) {
    const notification = all.value.find(notification => notification.id === id)
    if (!notification.read_at) {
      notification.read_at = new Date()
      play.notification.update_as_read({
        id
      }).then(fetch)
    }
  }

  function $reset() {}

  watch(() => authStore.authorization, () => {
    fetch()
  }, {
    immediate: true,
  })

  return {
    all,
    fetch,
    $reset,
    getUnreadCount,
    getFirsts,
    markAsRead
  }
})

export default useNotificationStore
